/* src/app/modules/ct-status/components/cts-gantry-startup-event-filter/cts-gantry-startup-event-filter.component.scss */
:host {
  display: block;
}
.filter-container {
  display: flex;
  gap: 0.5rem;
  padding: 0.25rem 0.25rem 0.1875rem 0.5rem;
  align-items: center;
  border: unset;
  border-radius: 0.125rem 0.125rem 0 0;
  border-bottom: 0.0625rem solid rgba(var(--ui-1), var(--opacity-4));
  background: rgba(var(--ui-1), var(--opacity-7));
  width: 16.3125rem;
  cursor: pointer;
  text-align: start;
}
.filter-container sh-icon {
  opacity: 0.6;
}
.event-date {
  font-weight: 400;
}
.filter-overlay {
  border-radius: 0 0 0.125rem 0.125rem;
  background: var(--base-4, #FFF);
  width: 21.0625rem;
  max-height: 25rem;
  box-shadow: 0 -0.0625rem 0.25rem 0 rgba(0, 0, 0, 0.05), 0 0.25rem 0.5rem 0 rgba(0, 0, 0, 0.1);
}
.filter-overlay sh-tabs {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.event-item-group {
  display: flex;
  flex-flow: column nowrap;
  margin-top: 0.5rem;
  max-height: 21rem;
  overflow-y: scroll;
}
.event-item {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  height: 3.5rem;
  cursor: pointer;
  border: none;
  background: var(--base-4, #FFF);
  width: 100%;
}
.event-item sh-text {
  text-wrap: nowrap;
  text-align: start;
  width: fit-content;
}
.event-item sh-text:last-of-type {
  overflow: hidden;
  text-overflow: ellipsis;
}
.event-item:hover:not(.event-item--selected) {
  background: rgba(var(--ui-1), var(--opacity-7));
}
.event-item--selected {
  background: rgba(var(--ui-1), var(--opacity-6));
}
.gray-badge {
  background: rgb(var(--ui-5, #7D7D7D));
}
.empty-state-container {
  display: flex;
  height: 17.25rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
}
/*# sourceMappingURL=cts-gantry-startup-event-filter.component.css.map */
